<template>
  <print-bill></print-bill>
</template>

<script>
import PrintBill from '../components/print-bill/index.vue';

export default { components: { PrintBill } };

</script>
